
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class DataItem extends Vue {
    @Prop({ default: '' }) title!: string;

}
